@if (hasMinMaxData) {
<div class="main-component w-100">
    <div #profilWrapper class="race-profil w-100"> </div>

    @if (displayPopUp) {
    <div class="modalPoint">
        <div class="modalHeader d-flex flex-row justify-content-between">
            <h5>{{checkpointSelected?.name}} - <span
                    class="elevation">{{checkpointSelected?.elevation?.elevation}}m</span></h5>
            <span class="close" (click)="closeModal()">X</span>
        </div>

        <div class="modalContent d-flex flex-column">
            <div class="info">
                Distance depuis le départ: {{(checkpointSelected?.distance ?? 0) / 1000}}km
            </div>
            <div class="info">
                Dénivelé depuis le départ: {{checkpointSelected?.elevation?.fromStart}}m D+
            </div>

            @if (checkpointSelected?.options) {

            }
            <div class="services d-flex flex-row justify-content-around">
                @for (service of checkpointsOptions | keyvalue; track $index) {
                @if (service.value) {
                <div class="service">
                    <img [src]="getServicesIcon(service.key)" alt="service.key" class="service-icon">
                </div>
                }
                }
            </div>
        </div>

        <div class="modalFooter">

        </div>

    </div>
    }



</div>
}